<script>
import { h } from 'vue'
import PerfectScrollbar from 'perfect-scrollbar'

export default {
  name: 'CScrollbar',
  props: {
    settings: { type: Object, default: () => ({}) },
    switcher: { type: Boolean, default: true },
    tag: { type: String, default: 'div' }
  },
  watch: {
    switcher (val) {
      val ? this.__init() : this.__uninit()
    }
  },
  mounted () {
    if (this.switcher) this.__init()
  },
  updated () {
    this.$nextTick(this.__update)
  },
  beforeUnmount () {
    this.__uninit()
  },
  methods: {
    __init () {
      if (!this._ps_bar) this._ps_bar = new PerfectScrollbar(this.$el, this.settings)
    },
    __uninit () {
      if (this._ps_bar) {
        this._ps_bar.destroy()
        this._ps_bar = null
      }
    },
    __update () {
      if (this._ps_bar) this._ps_bar.update()
    }
  },
  render () {
    return h(this.tag, { style: 'position: relative' }, this.$slots.default ? this.$slots.default() : undefined)
  }
}
</script>

<style scoped src="perfect-scrollbar/css/perfect-scrollbar.css"></style>
